import cx from 'classnames';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import type { FormBadgeListProps } from '@gov-nx/ui/types';
import { TabsNav } from '../Navigation/TabsNav';

export const FormBadges = (props: FormBadgeListProps) => {
	const formContext = useFormContext();

	return (
		<Controller
			name={props.field.name}
			control={formContext.control}
			render={({ field }) => (
				<TabsNav>
					{props.options.map((option) => {
						const value = field.value?.[option.name];
						return (
							<li
								key={option.name}
								className="gov-tabs__item">
								<button
									role="tab"
									className={cx('gov-tabs__btn', value ? 'selected' : '')}
									aria-selected={value}
									onClick={() => {
										const updated = props.options.reduce(
											(all, current) => ({
												...all,
												[current.name]: option.name === current.name,
											}),
											{}
										);

										field.onChange(updated);

										field.onBlur();
									}}>
									{option.label}
								</button>
							</li>
						);
					})}
				</TabsNav>
			)}
		/>
	);
};
